export default {"src":"/_next/static/media/bch.4b6d4251.svg","height":34,"width":91,"blurWidth":0,"blurHeight":0};